// extracted by mini-css-extract-plugin
export default {"primary_btn":"styles_primary_btn__+JENV","primary_btn_md":"styles_primary_btn_md__ieWqR"};